
<template>
  <div class="d-block text-justify">
  </div>
</template>
<script>
import { getFintoc } from '@fintoc/fintoc-js';

export default {
  name: "widgetFintoc",
  components: {
  },
  props: {
    payment_id: {
      type: String,
      required: true
    },
    project_id: {
      type: Number,
      required: true
    }
  },
  data(){
    return {
      loading: true,
      widget_fintoc: null,
    }
  },
  mounted() {
    // Smart Checkout es opcional por cuenta; ante cualquier error se sigue con el widget de siempre
    this.axios.get("payments/fintoc_settings", {params: {project_id: this.project_id}}).then(result => {
      if (result.data && result.data.smart_checkout_enabled) {
        this.smart_checkout()
      } else {
        this.direct_payment()
      }
    }).catch(() => {
      this.direct_payment()
    })
  },
  computed: {
    contract_id(){
				return this.$store.getters.getContractId == undefined ? null : this.$store.getters.getContractId
			},
  },
  methods: {
    direct_payment() {
      this.axios.post("payments/fintoc_payments", {contract_id: this.contract_id, payment_id: this.payment_id, project_id: this.project_id}).then(result => {
        this.widget_method(result.data.widget_token, result.data.public_key)
        this.$emit('closeModalPayment', false);
      }).catch(error => {
        console.log(error)
        this.destroy_widget()
      })
    },
    smart_checkout() {
      let back_url = window.location.origin + window.location.pathname
      this.axios.post("payments/fintoc_checkout_session", {
        contract_id: this.contract_id,
        payment_id: this.payment_id,
        project_id: this.project_id,
        success_url: back_url + "?fintoc_checkout=success",
        cancel_url: back_url + "?fintoc_checkout=cancel"
      }).then(result => {
        if (!result.data || !result.data.redirect_url) return this.direct_payment()
        window.location.assign(result.data.redirect_url)
      }).catch(error => {
        console.log(error)
        if (error.response && error.response.status === 409) {
          this.$swal('Atención', error.response.data.message, 'warning')
          return this.destroy_widget()
        }
        this.direct_payment()
      })
    },
    async widget_method (widgetToken, public_key) {
      let options = {
        holderType: 'individual',
        widgetToken: widgetToken,
        product: 'payments',
        publicKey: public_key,
        onExit: () => { this.destroy_widget() },
        onSuccess: (data) => { this.succes_transac(data)}
      }
      const Fintoc = await getFintoc();
      this.widget = Fintoc.create(options);
      this.widget.open();
    },
    destroy_widget() {
      this.$emit('showWidget', false);
    },
    succes_transac(data){
      this.$swal('Éxito', 'Transacción realizada con éxito', 'success');
      this.$emit('dataResultWidget', data);
    }
  }
}
</script>
